import {invoiceReceiptDateTime} from 'utils/formatter'
import styles from './InfoBox.css'

class TransactionDetailReceiptInfoBox extends React.Component {
  render () {
    let {paymentDetail, paymentRefund} = this.props
    return (
      <div className={styles['receipt-info-box']}>
        <div className={styles['receipt-date']}>
          <div className='pull-left'>{ invoiceReceiptDateTime(paymentRefund.refunded_at, 'date') }</div>
          <div className='pull-right'>{ invoiceReceiptDateTime(paymentRefund.refunded_at, 'time') }</div>
        </div>
        <div className={styles['receipt-number']}>
          <div className='pull-left'>Receipt Number</div>
          <div className='pull-right'>{ paymentDetail.payment_no }</div>
        </div>
        {paymentDetail.table_name && <div className={styles['receipt-number']}>
          <div className='pull-left'>Table Name</div>
          <div className='pull-right'>{ paymentDetail.table_name }</div>
        </div>}
        <div className={styles['receipt-collected']}>
          <div className='pull-left'>Refunded By</div>
          <div className='pull-right'>{ paymentRefund.refunded_by }</div>
        </div>
      </div>
    )
  }
}

TransactionDetailReceiptInfoBox.propTypes = {
  paymentDetail: React.PropTypes.object,
  paymentRefund: React.PropTypes.object
}

export default TransactionDetailReceiptInfoBox



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/InfoBox/RefundInfoBox.js